import { isLoggedIn } from "@shapr3d/frontend-lib";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { SearchParam } from "../../types";

export const AuthLayout = () => {
  const location = useLocation();

  if (isLoggedIn()) {
    return <Outlet />;
  }

  const redirectURL = new URL(window.location.href);
  redirectURL.searchParams.delete(SearchParam.AuthHint);

  const searchParams = new URLSearchParams(location.search);
  searchParams.set(SearchParam.RedirectUrl, encodeURIComponent(redirectURL.toString()));

  const authHint = searchParams.get(SearchParam.AuthHint);
  searchParams.delete(SearchParam.AuthHint);

  const hashParams = new URLSearchParams(location.hash.replace("#", "?"));
  const emailHint = hashParams.get(SearchParam.EmailHint);
  const allowedHashParams = new URLSearchParams();
  if (emailHint) {
    allowedHashParams.set(SearchParam.EmailHint, emailHint);
  }

  return (
    <Navigate
      to={{
        pathname: authHint === "signup" ? "/signup" : "/login",
        search: searchParams.toString(),
        hash: allowedHashParams.toString(),
      }}
      replace={true}
    />
  );
};
